module.exports = __webpack_public_path__ + "img/uniform-martial-arts.d0f31557.svg";